import { Button } from '@sw-sw/lib-ui';
import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../../contexts/AppContext';
import { FormContext } from '@sw-sw/lib-form';
import HubspotReportModal from './HubspotReportModal';

// TC-18: even with the feature enabled, only these roles may see/generate the
// report. The backend generate endpoint enforces this authoritatively; this is
// the matching UI gate.
const ALLOWED_ROLES = ['Super Admin', 'Admin', 'Billing Admin'];

export const HubspotReport: React.FC = () => {
  const appContext = useContext(AppContext);
  const formContext = useContext(FormContext);
  const [showModal, setShowModal] = useState(false);

  const roleName = appContext.get('user')?.roleName;
  const canGenerate = ALLOWED_ROLES.includes(roleName);

  // Seed sensible filter defaults the modal opens with.
  useEffect(() => {
    formContext.set('scope', 'all');
    formContext.set('range', 'ytd');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!canGenerate) {
    return (
      <div className='hubspot-report'>
        <h2>HubSpot Report</h2>
        <p>You don't have access to generate this report.</p>
      </div>
    );
  }

  return (
    <div className='hubspot-report'>
      <header className='hubspot-report__header'>
        <h2>HubSpot Report</h2>
        <p>
          Export projects as HubSpot-style deals (contract value, award date,
          start status, company &amp; contact details). Choose a scope and date
          range, and we'll email you a secure download link when the file is ready.
        </p>
        <Button onClick={() => setShowModal(true)}>Generate Report</Button>
      </header>

      {showModal && <HubspotReportModal setShowModal={setShowModal} />}
    </div>
  );
};

export default HubspotReport;
